import EventSessionListActionTypes from '../actions/event-session-list-action-types';
import { pagingSettings } from '../../../utils/GridPagingUtils';

const initialState = {
  loading: false,
  sessions: [],
  skip: pagingSettings.paging.skip,
  take: pagingSettings.paging.take,
  total: 0,
  isConfirmDialogVisible: false,
  selectedSessionId: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EventSessionListActionTypes.LOAD_EVENT_SESSION_LIST_START:
      return {
        ...state,
        loading: true
      };
    case EventSessionListActionTypes.LOAD_EVENT_SESSION_LIST_END:
      return {
        ...state,
        loading: false,
        sessions: action.payload?.sessions,
        total: action.payload?.total,
        skip: action.payload?.skip,
        take: action.payload?.take
      };
    case EventSessionListActionTypes.TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG:
      return {
        ...state,
        isConfirmDialogVisible: !!action.payload,
        selectedSessionId: action.payload ? action.payload.id : null,
        confirmDialogErrorMessage: null
      };
    case EventSessionListActionTypes.SET_CONFIRM_DIALOG_ERROR:
      return {
        ...state,
        confirmDialogErrorMessage: action.payload?.errorMessage
      };
    default:
      return state;
  }
};
